import React, { ReactNode, useEffect, useState } from "react";
import Navbar from "src/component/navbar/navbar";
import InnerNavbar from "src/component/navbar/innerNavbar";
import CRMNavbar from "src/component/navbar/crmNavbar"; // ✅ CRMNavbar import
import { useLocation } from "react-router-dom";
import Footer from "src/component/footer/footer";
import AuthInnerNavbar from "../navbar/authInnerNavbar";

interface AuthLayoutProps {
  children: ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const[IsCRMLogin, setIsCRMLogin] = useState(false); 


  useEffect(() => {
    const IsCRMLogin = sessionStorage.getItem("IsCRMLogin") === "true";

    if (IsCRMLogin) {
      setIsCRMLogin(true);
    } else {
      setIsCRMLogin(false);
    }
  }, [window.location.pathname]);



  const location = useLocation();
  const path = location.pathname;

  const isLoginPage = path === "/login" || path === "/Sign_up";
  const isCompanyLoginPage = path === "/company";
  const isCRMLoginPage = path === "/Login";
  const isHomePage = path === "/";
  //const isCRMPage = path.startsWith("/dashboard") || path.startsWith("/enquiryReport");

  const shouldShowNavbar = !isLoginPage && !isCompanyLoginPage && !isCRMLoginPage;
  const shouldShowFooter = shouldShowNavbar && !IsCRMLogin;

  return (
    <div>
      {IsCRMLogin ? (
        <AuthInnerNavbar/>
      ) : shouldShowNavbar && (isHomePage ? (
        <Navbar />
      ) : (
        <InnerNavbar />
      ))}

      {children}

      {shouldShowFooter && <Footer />} {/* ✅ Conditionally show footer */}
    </div>
  );
};

export default AuthLayout;
